export default "__VITE_ASSET__BNeM_YG8__"